var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",attrs:{"playsinline":true,"options":_vm.playerOptions},on:{"play":function($event){return _vm.onPlayerPlay($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }